import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';



const ICONOS_CATEGORIA = {
    Pago: "bi-credit-card",
    Chat: "bi-chat-dots",
    Soporte: "bi-life-preserver",
    Reserva: "bi-calendar-check",
    Servicio: "bi-bag-check",
    Sistema: "bi-bell",
};

function ListaNotificaciones({ usuario, rolDestino }) {
    const navigate = useNavigate();

    const [notificaciones, setNotificaciones] = useState([]);
    const [cargando, setCargando]              = useState(false);
    const [paginaActual, setPaginaActual]      = useState(1);
    const [totalPaginas, setTotalPaginas]      = useState(1);

    useEffect(() => {
        (async () => {
            if (!usuario?.idUsuario || !rolDestino) return;

            try {
                setCargando(true);

                const respuesta = await axios.post("/notificaciones/obtener-notificaciones", {
                    params: { idUsuario: usuario.idUsuario, rolDestino, pagina: paginaActual, limite: 10 },
                });

                setNotificaciones(respuesta?.data?.notificaciones || []);
                setTotalPaginas(respuesta?.data?.paginacion?.totalPaginas || 1);
            }
            catch (err) {
                console.log("error al obtener notificaciones: ", err);
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, rolDestino, paginaActual]);

    function eliminarNotificacion(idNotificacion) {
        Swal.fire({
            icon: 'warning',
            title: "¿Eliminar notificación?",
            text: "Esta acción no se puede deshacer.",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            try {
                await axios.post("/notificaciones/eliminar-notificacion", {
                    params: { idNotificacion, idUsuario: usuario.idUsuario },
                });

                setNotificaciones((actuales) => actuales.filter((notificacion) => notificacion.idNotificacion !== idNotificacion));
            }
            catch (err) {
                console.log("error al eliminar notificación: ", err);
                Swal.fire({
                    icon: 'error',
                    title: "Error",
                    text: "No se pudo eliminar la notificación. Intenta de nuevo.",
                    customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
                });
            }
        });
    }

    function abrirNotificacion(notificacion) {
        if (notificacion?.urlDestino) { navigate(notificacion.urlDestino); }
    }

    return (
        <div className="container mb-5 pb-4">
            {cargando ? (
                <div className="alert alert-light border">Cargando notificaciones...</div>
            ) : notificaciones.length === 0 ? (
                <div className="alert alert-light border">No tienes notificaciones todavía.</div>
            ) : (
                <div className="d-flex flex-column gap-3">
                    {notificaciones.map((notificacion) => (
                        <div
                            key={notificacion.idNotificacion}
                            className="card shadow-sm border-0 rounded-4"
                            style={{ background: notificacion.leida ? "var(--blanco)" : "rgba(var(--azul-bootstrap-cta-rgb), 0.05)" }}
                        >
                            <div className="card-body px-4 py-3 d-flex align-items-start justify-content-between gap-3">
                                <div
                                    className="d-flex align-items-start gap-3"
                                    style={{ cursor: notificacion.urlDestino ? "pointer" : "default", flex: 1 }}
                                    onClick={() => abrirNotificacion(notificacion)}
                                >
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                        style={{ width: "44px", height: "44px", background: "rgba(var(--azul-medio-rgb), 0.08)" }}
                                    >
                                        <i className={`bi ${ICONOS_CATEGORIA[notificacion.categoria] || "bi-bell"}`} style={{ fontSize: "1.2rem", color: "var(--color-text-primary)" }}></i>
                                    </div>

                                    <div className="d-flex flex-column">
                                        <span className="fw-bold text-dark" style={{ fontSize: "0.98rem" }}>{notificacion.titulo}</span>
                                        <span className="text-secondary mt-1" style={{ fontSize: "0.92rem" }}>{notificacion.mensaje}</span>
                                        <span className="text-secondary mt-2" style={{ fontSize: "0.8rem" }}>
                                            {notificacion.createdAt ? new Date(notificacion.createdAt).toLocaleString("es-CO", {
                                                day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
                                            }) : "NA"}
                                        </span>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-outline-danger rounded-pill px-3 py-2 flex-shrink-0"
                                    onClick={() => eliminarNotificacion(notificacion.idNotificacion)}
                                    title="Eliminar notificación"
                                >
                                    <i className="bi bi-trash"></i>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {totalPaginas > 1 && (
                <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                    <button
                        type="button"
                        className="btn btn-outline-secondary rounded-pill px-3"
                        disabled={paginaActual <= 1}
                        onClick={() => setPaginaActual((actual) => Math.max(1, actual - 1))}
                    >
                        Anterior
                    </button>

                    <span className="text-secondary">Página {paginaActual} de {totalPaginas}</span>

                    <button
                        type="button"
                        className="btn btn-outline-secondary rounded-pill px-3"
                        disabled={paginaActual >= totalPaginas}
                        onClick={() => setPaginaActual((actual) => Math.min(totalPaginas, actual + 1))}
                    >
                        Siguiente
                    </button>
                </div>
            )}
        </div>
    );
}

export default ListaNotificaciones;
